import { IMapSelection, TMapSelection } from '../../../Map/types/mapSelection';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMapSelectionActionType {
  Changed = 'map/selectionChanged',
  FeatureUpdated = 'map/selectionFeatureUpdated',
}

export type TMapSelectionChangedAction = ITypedReduxAction<EMapSelectionActionType.Changed, TMapSelection>;
export type TMapSelectionFeatureUpdatedAction = ITypedReduxAction<
  EMapSelectionActionType.FeatureUpdated,
  IMapSelection
>;

export type TMapSelectionActions = TMapSelectionChangedAction | TMapSelectionFeatureUpdatedAction;
